import { useEffect, useRef } from 'react';

/**
 * Custom hook to manage z-index of external elements
 *
 * @param {string} selector - CSS selector for the external element to manage
 * @param {number} targetZIndex - Z-index value to apply to the element
 * @param {boolean} isActive - Whether to apply the z-index change
 */

export const useZIndexManager = (selector, targetZIndex, isActive) => {
  const originalZIndex = useRef(null);
  const elementRef = useRef(null);

  useEffect(() => {
    let element = document.querySelector(selector);

    if (!element) {
      return () => {};
    }

    elementRef.current = element;

    if (isActive) {
      if (originalZIndex.current === null) {
        const computedZIndex = window.getComputedStyle(element).zIndex;
        originalZIndex.current = element.style.zIndex || computedZIndex;
      }
      element.style.zIndex = targetZIndex;
    } else if (originalZIndex.current !== null) {
      element.style.zIndex = originalZIndex.current;
      originalZIndex.current = null;
    }

    return () => {
      if (elementRef.current && originalZIndex.current !== null) {
        elementRef.current.style.zIndex = originalZIndex.current;
        originalZIndex.current = null;
      }
    };
  }, [selector, targetZIndex, isActive]);
};
